import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-refresh",
  standalone: true,
  imports: [],
  templateUrl: "./refresh.component.html",
  styleUrl: "./refresh.component.scss",
})
export class RefreshComponent {
  @Input() refreshing: boolean = false;
  @Input() lastUpdatedText: string = "";

  @Output() refresh = new EventEmitter();

  onRefresh() {
    this.refresh.emit();
  }
}
